<template>

    <SubHeader title="Fiche agent" :breads="[{ name: 'Créer Secteur' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(data)">

                <div class="row">
                    <div class="col-md-12">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" id="label" v-model="data.label" class="form-control" placeholder="Secteur">
                                </div>
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label"  for="division">Division</label>
                                    <m-select v-model="data.type" :loading="divisionIsLoading"  :required="true" :options="divisionItems" :searchable="false" 
                                        placeholder="Type de division" track-by="id" label="label" >
                                    </m-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Enregistrer</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import {mapFields} from "vuex-map-fields"
import {mapActions} from "vuex"

export default {
    name: "AdminConfigCreateSecteur",
    components: {
        SubHeader
    },
    data(){
        return{
            data:{}
        }
    },
    computed: {
        ...mapFields("secteur/create", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items",
            isCreated:"isCreated"

        }),
        ...mapFields("division/list", {
            divisionIsLoading: "isLoading",
            divisionIsSuccess: "isSuccess",
            divisionShowMessage: "showMessage",
            divisionMessage: "message",
            divisionItems: "items"

        })
    },

    methods: {
        ...mapActions({
            handleSubmit: "secteur/create/create",
            reset: "secteur/create/resetData",
            getDivisions: "division/list/getAll",
            
        })
    },
    watch:{
        "data.type"(val){
            if(val){
                this.data.division_id = val.id ?? null
            }
        },
        isCreated(val){
            if(val){
                this.$router.push({name:'AdminConfigSecteur'})
            }
        }
    },

    unmounted() {
        this.reset()
    },
    mounted() {
        this.getDivisions()
    }
}
</script>
